<div>
  <div class="col-md-12 col-lg-12" style="min-height:50px;">
    <div>
      <div class="col-sm-3 col-md-12"><h4><b>{{ 'pages.createReceiptPage.enterAWB' | translate }}</b></h4></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="form-group">
            <textarea rows="4" cols="25" style="resize:none" [placeholder]="'pages.createReceiptPage.enterMultipleAwb' | translate" [(ngModel)]="shipmentNumber"></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-4">
          <button class="btn btn-primary" (click)="serachAwbNumber()">{{ 'common.search' | translate }}</button>
        </div>
      </div>

    </div>
    <div class="container">
      <div class="details-container over-flow" *ngIf="isOpen && shipments.length>0">
        <div class="row" *ngIf = "!isSpotter">
          <table class="table">
            <thead>
              <tr>
                <th>{{ 'pages.createReceiptPage.awb' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.shipperName' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.consigneeName' | translate }}</th>
                <th>{{ 'common.weight' | translate }}</th>
                <th>{{ 'common.unit' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.dropOffAwb.cashValue' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.dropOffAwb.reweightNeeded' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.dropOffAwb.newWeight' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.dropOffAwb.newCost' | translate }}</th>
                <th>{{ 'common.action' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let shipment of shipments">
                <td>{{shipment?.Number}}</td>
                <td>{{shipment.ShipperName}}</td>
                <td>{{shipment.ConsigneeName}}</td>
                <td>{{shipment.OldGrossWeight?.Value}}</td>
                <td>{{shipment.OldGrossWeight?.Unit}}</td>
                <td>{{shipment.CashValue.Value + " " + branchCurrencyCode}}</td>
                <td class="reweight">
                  <img class="reweight-icon" src="assets/img/tick.svg" *ngIf="shipment?.ReWeightNeeded == true ; else other_content" />
                  <ng-template #other_content>
                    <img class="reweight-icon" src="assets/img/cross.svg" />
                  </ng-template>
                </td>
                <td class="no-arrow">
                  <input type="number" min="0" class="form-control" (change)="onChangeWeight($event, shipment?.Number)" [disabled]="shipment?.ReWeightNeeded == false"/>
                  <span class="error-msg">{{getNewWeightError(shipment?.Number)}}</span>
                </td>
                <td>
                  <span *ngIf="shipment?.ReWeightNeeded == false ; else new_cost">-</span>
                  <ng-template #new_cost>
                    <span>{{getNewCost(shipment?.NewCost)}}</span>
                  </ng-template>
                </td>
                <td class="action" (click)="removeShipment(shipment)"><span class="armx-trash-empty"></span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row" *ngIf = "isSpotter">
          <table class="table">
            <thead>
              <tr>
                <th>{{ 'pages.createReceiptPage.awb' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.shipperName' | translate }}</th>
                <th>{{ 'pages.createReceiptPage.consigneeName' | translate }}</th>
                <th>{{ 'common.action' | translate }}</th>
                <th>{{ 'common.PrintLabel' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let shipment of shipments">
                <td>{{shipment?.Number}}</td>
                <td>{{shipment.ShipperName}}</td>
                <td>{{shipment.ConsigneeName}}</td>
                <td class="action" (click)="removeShipment(shipment)"><span class="armx-trash-empty"></span></td>
                <td><input type="checkbox" class="printlabel" (click) = "onShipmentCheck(shipment.Number)"> </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
 <div class="mt-15 mb-30" *ngIf="isOpen && shipments.length > 0">
  <div class="d-flex flex-wrap">
    
    <button 
      *ngIf="!isSpotter"
      [disabled]="!isCalculateEnable"
      class="btn btn-info mr-2 mb-2"
      (click)="onCalculateClick()">
      {{ 'common.calculate' | translate }}
    </button>

    <button 
      class="btn btn-info mr-2 mb-2"
      (click)="onAddReceiptClick()" 
      [disabled]="isNewCalculationNeeded">
      {{ 'common.addToReceipt' | translate }}
    </button>

    <button 
      class="btn btn-info mr-2 mb-2"
      (click)="openPopup()">
      {{ 'common.addToReceiptRTILogic' | translate }}
    </button>

  </div>
</div>
<div>
    <add-to-receipt-drop-off-rti (onRTIShipment)="handleRTIShipmentFromRTI($event)" [shippmentsRTI]="shipmentsForRtiPopup" ></add-to-receipt-drop-off-rti>
</div>
